<template>
  <section class="content" id="rondesList">
    <message
      :obj=rondes.importModal.message
      hide-mutation-type="CLEAR_RONDES_IMPORT_MESSAGE">
    </message>
    <section class="content-toolbar">
      <button class="btn btn-primary" v-on:click='createRonde()'>
        Ajouter une ronde
      </button>
      <button class="btn import-btn btn-primary" v-on:click='importRondes()'>
        Importer des rondes en masse
      </button>
      <button class="btn export-btn btn-primary" v-on:click='downloadAdresses()'>
        Télécharger les adresses
      </button>
      <button class="btn export-btn btn-primary" v-on:click='downloadTemplateFile'>
        Télécharger le fichier template
      </button>
    </section>

    <ronde-update-modal
      v-if="rondes.updateModal.visible"
      :hide-dispatch-action="closeRondeUpdateModal"
      :ronde="selectedRonde">
    </ronde-update-modal>

    <ronde-create-modal
      v-if="rondes.createModal.visible"
      :hide-dispatch-action="closeRondeCreateModal">
    </ronde-create-modal>


    <RondesImportModal v-if="rondes.importModal.visible">
      <ronde-form-csv slot="body">

      </ronde-form-csv>
    </RondesImportModal>


    <div v-for="r in rondes.data">
      <content-row
        :not-openable="true"
        :edit="true" @edit="editRonde(r)"
        :select="true" @select="goToRonde(r)">

        <div slot="main">
          <div class="col-sm-4 right-separator">
            <span class="title-item">RONDE</span>
            <span class="text-item">{{ r.nom }}</span>
          </div>
          <div class="col-sm-2 right-separator">
            <span class="title-item">BOM</span>
            <span class="text-item">{{ r.numero }}</span>
          </div>
          <div class="col-sm-2 right-separator">
            <span class="title-item">INTERVENTIONS</span>
            <span class="text-item">{{ r.nbInterventions }}</span>
          </div>
          <div class="col-sm-2 right-separator">
            <span class="title-item">REFERENT</span>
            <span class="text-item text-item--sm break-word">{{ r.loginRef }}</span>
          </div>
          <div class="col-sm-2">
            <span class="title-item">PLANIFIE</span>
            <span class="text-item text-item--sm break-word">{{ r.loginPla }}</span>
          </div>
        </div>
      </content-row>
    </div>
    <div class="loading-overlay" v-if="rondes.searching">
      Chargement ...
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import {mapState} from 'vuex'
import ContentRow from '../../shared/ContentRow'
import RondeCreateModal from './RondeCreateModal'
import RondeUpdateModal from './RondeUpdateModal'
import RondesImportModal from './RondesImportModal.vue'
import RondeFormCsv from './RondeFormCsv.vue'
import XLSX from 'xlsx'
import agentLoginFormatter from '../../../utils/agentLoginFormatter'
import Papa from 'papaparse'
import moment from 'moment'
import Message from '../../shared/Message'

export default {
  components: {
    RondeFormCsv,
    ContentRow,
    Message,
    RondeCreateModal,
    RondeUpdateModal,
    RondesImportModal,
  },
  data: function () {
    return {
      selectedRonde: null,
    }
  },
  computed: {
    ...mapState([
      'rondes',
      'adresses'
    ]),
  },
  methods: {
    createRonde: function () {
      this.$store.dispatch('showRondeCreateModalV2')
    },
    importRondes: function () {
      this.$store.dispatch('showRondeImportModalV2')
    },
    downloadAdresses: async function () {
      await this.$store.dispatch('fetchAdresses')
      this.asignCsvValue(this.adresses.data)
    },
    downloadTemplate: async function () {
      this.asignCsvValue([])
    },
    editRonde: function (ronde) {
      this.selectedRonde = _.cloneDeep(ronde)
      this.$store.dispatch('showRondeUpdateModalV2')
    },
    goToRonde: function (ronde) {
      this.$router.push({name: 'Ronde', params: {id: ronde.id}})
    },
    countInterventions: function (interventions) {
      let count = 0
      interventions.forEach(intervention => {
        if (intervention.is_debut_ou_fin_jalon === undefined) {
          count++
        }
      })
      return count
    },
    asignCsvValue: function (data) {
      console.log('asignCsvValue')
      var result = data.map(function (value) {
        return {
          'Identifiant': value.id,
          'Ville': value.ville,
          'Numéro': value.numero,
          'Voie': value.voie,
          'Bacs OM': value.bacsOm,
          'Bacs CS': value.bacsCs,
        }
      })
      this.makeCSV(result)
    },
    makeCSV: function (data) {
      var content = Papa.unparse({
        encoding: 'UTF-8',
        fields: [
          'Identifiant',
          'Ville',
          'Numéro',
          'Voie',
          'Bacs OM',
          'Bacs CS',
        ],

        data: data,
      })
      this.prompCsvDownload(content)
    },
    prompCsvDownload: function (content) {
      var csvData = new window.Blob([
        '\uFEFF' + content, // prepend utf8's BOM fixes excel import it seems
      ], {
        type: 'text/csv;charset=WINDOWS-1252;',
      })
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(csvData, 'adresses.csv')
      } else {
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(csvData)
        link.setAttribute('download', 'adresses.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    downloadTemplateFile: function () {
      var wb = XLSX.utils.book_new()
      wb.Props = {
        Title: 'Template rondes',
        Subject: 'Fichier d\'import des nouvelles rondes',
        Author: 'SUEZ',
        CreatedDate: moment().format('YYYY-MM-DD'),
      }
      wb.SheetNames.push('Feuille1')
      var wsData = [['nom_ronde', 'numero_ronde', 'debut_jalon', 'id_adresse', 'fin_jalon']]
      var ws = XLSX.utils.aoa_to_sheet(wsData)
      wb.Sheets['Feuille1'] = ws
      var wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'})

      function s2ab (s) {
        var buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
        return buf
      }

      // saveAs(new window.Blob([ s2ab(wbout), ], {type: 'application/octet-stream'}), 'template.xlsx')
      var templateFile = new window.Blob([s2ab(wbout),], {type: 'application/octet-stream'})
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(templateFile, 'template.xlsx')
      } else {
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(templateFile)
        link.setAttribute('download', `template.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  },
  mounted: async function () {
 //   this.$store.commit('RONDES_SEARCHING')
    await this.$store.dispatch('fetchAgentsV2')
    await this.$store.dispatch('fetchJalonsV2')
    await this.$store.dispatch('fetchRondesV2')

  },
  beforeDestroy() {
    console.log("Leaving the page - Perform cleanup here");
   // this.rondes.data = []
  }
}
</script>

<style lang="scss">
@import '../../../scss/variables';

.export-btn {
  background-image: url('/static/img/btn-export.svg');
  background-repeat: no-repeat;
  background-position: 15px center;
  padding: 7px 15px 8px 45px;

}

.import-btn {
  background-image: url('/static/img/btn-upload.svg');
  background-repeat: no-repeat;
  background-position: 15px center;
  padding: 7px 15px 8px 45px;

}
</style>



// WEBPACK FOOTER //
// RondesList.vue?723f198f